import { RefreshDouble } from 'iconoir-react'
import { useMemo } from 'react'
import SimpleTable from 'app/components/table/SimpleTable'
import { appointmentTypesAgentColumns } from 'app/table-columns/appointment-types'
import { AIAgentConfigurationType } from 'app/types/entities'
import type { UseAiAgentAppointmentTypesReturn } from './useAiAgentAppointmentTypes'

export type AiAgentAppointmentTypesComponentProps = UseAiAgentAppointmentTypesReturn

export function AiAgentAppointmentTypesComponent(props: AiAgentAppointmentTypesComponentProps) {
  const {
    rows,
    agentConfigState,
    isSyncing,
    onToggleActive,
    openEditAppointmentTypeModal,
    handleRefreshClick,
    handleAppointmentCategoryChange,
  } = props

  const columns = useMemo(
    () =>
      appointmentTypesAgentColumns(
        onToggleActive,
        handleAppointmentCategoryChange,
        agentConfigState,
        openEditAppointmentTypeModal,
      ),
    [agentConfigState],
  )

  return (
    <div className="mt-4 flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <p className="text-ui-sm text-strong">Types</p>
        <button className="btn btn-xs btn-tertiary gap-2" disabled={isSyncing} onClick={() => handleRefreshClick()}>
          <RefreshDouble className={isSyncing ? `animate-spin` : ``} /> <p>Sync appointment types</p>
        </button>
      </div>
      <SimpleTable
        columns={columns}
        data={rows}
        showColumnOrdering={false}
        noDataMessage="No appointment types found"
        hideFooter={true}
      />
    </div>
  )
}
